import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../Context/useAuth";
import "./Geometry.css";

import geoImage from "../../Assets/geo-dual-suspension-bikes.svg";
import { GeometryModel } from "../../Models/GeometryModel";
import { Table } from "react-bootstrap";


interface Props {
  geoModel: GeometryModel;
}

const GeometrySection = (props: Props) => {
  const { isLoggedIn, user, logout } = useAuth();
  return (
    <div className="container mt-5">
        <div className="card shadow-sm p-4">
            <div className="row align-items-center">
                <div className="col-md-12">
                    <img
                    src={geoImage} className="hero-image p-0 img-fluid rounded"
                    alt="Part"
                    />
                </div>
            </div>
            <div className="row align-items-center">
                <div className="col-md-12">
                    <h3>Geometry</h3>
                </div>
            </div>
            <Table striped bordered hover>
                <thead>
                    <tr>
                    <th>Measurement</th>
                    <th>XL</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Stack (A)</td>
                        <td>{ props.geoModel.stack }cm</td>
                    </tr>
                    <tr>
                        <td>Reach (B)</td>
                        <td>{ props.geoModel.reach }cm</td>
                    </tr>
                    <tr>
                        <td>Head Tube Angle (C)</td>
                        <td>{ props.geoModel.head_tube_angle }°</td>
                    </tr>
                    <tr>
                        <td>Head Tube Length (D)</td>
                        <td>{ props.geoModel.head_tube_length }cm</td>
                    </tr>
                    <tr>
                        <td>Seat Tube Angle (E)</td>
                        <td>{ props.geoModel.seat_tube_angle }°</td>
                    </tr>
                    <tr>
                        <td>Seat Tube Length (F)</td>
                        <td>{ props.geoModel.seat_tube_length }cm</td>
                    </tr>
                    <tr>
                        <td>Top Tube Effective (G)</td>
                        <td>{ props.geoModel.top_tube_effective }cm</td>
                    </tr>
                    <tr>
                        <td>Bottom Bracket Height (H)</td>
                        <td>{ props.geoModel.bb_height }cm</td>
                    </tr>
                    <tr>
                        <td>Bottom Bracket Drop (I)</td>
                        <td>{ props.geoModel.bb_drop }cm</td>
                    </tr>
                    <tr>
                        <td>Chainstay (J)</td>
                        <td>{ props.geoModel.chainstay }cm</td>
                    </tr>
                    <tr>
                        <td>Wheel Base (K)</td>
                        <td>{ props.geoModel.wheel_base }cm</td>
                    </tr>
                    <tr>
                        <td>Standover Height (L)</td>
                        <td>{ props.geoModel.stadover_height }cm</td>
                    </tr>
                    <tr>
                        <td>Handle Bar Width</td>
                        <td>{ props.geoModel.handle_bar_width }cm</td>
                    </tr>
                    <tr>
                        <td>Stem Length</td>
                        <td>{ props.geoModel.stem_length }cm</td>
                    </tr>
                </tbody>
            </Table>
        </div>
    </div>
  );
}

export default GeometrySection;
